module.exports = __webpack_public_path__ + "29c4ec1e5c6b790e322b308f66765ac9.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/components/face/data-smart/images/illustrations_01.png
// module id = 931
// module chunks = 3